export const BASE_URL = stripSlash(process.env.API_URL || 'http://www.kurjerzy.pl/') + '/';
export const API_URL = BASE_URL + 'ajax';
export const POINTS_URL = process.env.POINTS_URL || 'https://punkty.kurjerzy.pl/map';

function stripSlash(str) {
    return str.replace(/\/+$/, '');
}